import { render } from "./LicenceAcceptanceScreen.vue?vue&type=template&id=33fed5f8&scoped=true"
import script from "./LicenceAcceptanceScreen.vue?vue&type=script&lang=js"
export * from "./LicenceAcceptanceScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=33fed5f8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33fed5f8"]])

export default __exports__